import { render, staticRenderFns } from "./StayCard.vue?vue&type=template&id=2cccc867&scoped=true"
import script from "./StayCard.vue?vue&type=script&lang=js"
export * from "./StayCard.vue?vue&type=script&lang=js"
import style0 from "./StayCard.vue?vue&type=style&index=0&id=2cccc867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cccc867",
  null
  
)

export default component.exports